import { Component, OnInit } from '@angular/core';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerScheduleCustomer',
  templateUrl: './LetterRequestCustomerScheduleCustomer.component.html',
  styleUrls: ['./LetterRequestCustomerScheduleCustomer.component.scss']
})
export class LetterRequestCustomerScheduleCustomerComponent implements OnInit {
  page:number=0;
  Procssing:boolean=false

  StartSearchDate:String=''
  EndSearchDate:String=''
  CustomerName:String=''

  BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/schedule?id="

  constructor(
    private login_Service: LoginService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService,
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
  ) { }

  ngOnInit() {

    this.BaseUrl=environment.BaseUrl + "Letterrequestcustomerprint/schedule?id="

    this.Nav_Service.CheckValidPage(1142).subscribe(
      data=>{
        this.login_Service.GetUserRole().subscribe(
          data2=>{
            this.CustomerName=data2['customerName']
          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  GetLetterRequestCustomerSchedule(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerScheduleCustomer(
      StartSearchDate,
      EndSearchDate).subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data

        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


}

